import { defineAbTest } from "libs/state/src/lib/ab-tests";
import {
  SHORTER_SUF_FLAG_KEY,
} from "libs/state/src/lib/stores/flows/fresh/signupFlow/constants";

/** Temporary flag to gate flavour/texture preference questions in the signup flow. */
export const SUF_PREFERENCE_QUESTIONS = defineAbTest({
  key: "suf-preference-questions",
  durability: "none",
});

export const SHORTER_SUF = defineAbTest({
  key: SHORTER_SUF_FLAG_KEY,
  durability: "user",
});
